const categories = [
  {
    icon: 'ri-heart-pulse-line',
    color: '#FF8C69',
    title: '醫療保險知識',
    desc: '醫療險、實支實付、住院手術、重大疾病等保障觀念，用生活化語言說清楚每一個保障細節。',
    tags: ['醫療險', '實支實付', '重大疾病', '住院手術'],
  },
  {
    icon: 'ri-home-heart-line',
    color: '#5C5470',
    title: '家庭保障規劃',
    desc: '家庭責任、收入中斷、子女照顧、父母照護等風險議題，協助您建立完整的家庭保障結構。',
    tags: ['家庭保障', '收入中斷', '子女照顧', '父母照護'],
  },
  {
    icon: 'ri-time-line',
    color: '#D4A373',
    title: '長期照護與退休',
    desc: '長照費用、退休金流、養老生活與資產防護，提前規劃讓您在人生後半段依然從容自在。',
    tags: ['長期照護', '退休規劃', '資產防護', '養老準備'],
  },
  {
    icon: 'ri-file-search-line',
    color: '#FF8C69',
    title: '理賠與保單健檢',
    desc: '理賠流程、保單條款、保障缺口、年度檢視，讓您在需要保障的時刻不慌不亂。',
    tags: ['理賠流程', '保單健檢', '保障缺口', '年度檢視'],
  },
];

export default function KnowledgeCategories() {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            CATEGORIES
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            內容分類
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => (
            <div
              key={cat.title}
              className="bg-[#F8F5F0] rounded-2xl p-7 border border-transparent hover:border-[#D4A373]/30 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
                style={{ backgroundColor: `${cat.color}18` }}
              >
                <i className={`${cat.icon} text-2xl`} style={{ color: cat.color }}></i>
              </div>
              <h3
                className="font-serif font-bold text-[#5C5470] mb-3"
                style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)', lineHeight: '1.45' }}
              >
                {cat.title}
              </h3>
              <p className="text-gray-600 mb-5" style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}>
                {cat.desc}
              </p>
              <div className="flex flex-wrap gap-2">
                {cat.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-full text-white font-medium"
                    style={{ fontSize: '1rem', backgroundColor: cat.color }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
